import { MrbBaseRouteStore } from "mrb/core";
import { CertifierDashboardService } from "common/services";

class CertifierDashboardRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.certifierDashboardService = rootStore.createApplicationService(CertifierDashboardService);
    }

    async findCertifierModes(filter) {
        const response = await this.certifierDashboardService.findCertifierModes(filter);
        return response.data;
    }

    async getSummary(modeId) {
        const response = await this.certifierDashboardService.getSummary(modeId);
        return response.data;
    }

    async findContent(modeId, filter) {
        const response = await this.certifierDashboardService.findContent(modeId, filter);
        return response.data;
    }

    async updateContentStatus(modeId, contentId, isApproved, contentType) {
        const response = await this.certifierDashboardService.updateContentStatus(modeId, contentId, isApproved, contentType);
        return response ? response.data : null;
    }

    async bulkUpdateContentStatus(modeId, payload) {
        const response = await this.certifierDashboardService.bulkUpdateContentStatus(modeId, payload);
        return response ? response.data : null;
    }
}

export default CertifierDashboardRouteStore;
